// extracted by mini-css-extract-plugin
export default {"active":"AddRemoveButton_active__fFIv1","menu":"AddRemoveButton_menu__9EOJP","submenu":"AddRemoveButton_submenu__FjlKZ"};